import { formatPercentCell } from '../../../../utils/formatPercent';
import styles from './ProductivityBar.module.css';

type ProductivityBand = 'excellent' | 'good' | 'fair' | 'poor';

function productivityBand(value: number): ProductivityBand {
  if (value >= 95) return 'excellent';
  if (value >= 80) return 'good';
  if (value >= 65) return 'fair';
  return 'poor';
}

interface IProductivityBarProps {
  value: number | null;
}

export function ProductivityBar({ value }: IProductivityBarProps) {
  if (value === null) return <span className={styles.unmeasured}>—</span>;

  const band = productivityBand(value);

  return (
    <div className={styles.cell}>
      <span className={styles.track}>
        <span
          className={styles.fill}
          data-band={band}
          style={{ width: `${Math.min(value, 100)}%` }}
        />
      </span>
      <span className={styles.value} data-band={band}>
        {formatPercentCell(value)}
      </span>
    </div>
  );
}